<template>
  <v-textarea
    name="url"
    :value="value.url"
    :counter="1500"
    rows="3"
    class="pt-2"
    outlined
    :rules="rules.url"
    :readonly="readonly"
    :error-messages="errors.url"
    :label="`${$t('APP_CONTENT.WEB_URL')}`"
    @input="updateValue('url', $event)"
  ></v-textarea>
</template>
<script>
import { requiredTextDescription } from '@/modules/_global/variables/rules';
import formEditable from '@/modules/_global/mixins/form-editable';
export default {
  name: 'UrlForm',

  mixins: [formEditable],
  props: {
    languageId: {
      type: Number,
      required: true
    },
    value: {
      type: Object,
      default: () => ({
        url: ''
      })
    }
  },
  data() {
    return {
      valid: true,
      rules: {
        url: requiredTextDescription
      }
    };
  },

  mounted() {
    this.$emit('input', { ...this.value, language_id: this.languageId });
  },
  methods: {
    updateValue(key, value) {
      this.$emit('update-prop', key, value);
      this.$emit('input', {
        ...this.value,
        language_id: this.languageId,
        [key]: value
      });
    }
  }
};
</script>

<style scoped></style>
